(() => {
  'use strict';

  if (window.BallonnenshopCustomerMailRewardsLoader) return;

  const MAX_LOAD_ATTEMPTS = 3;
  const RETRY_DELAY_MS = 5_000;
  const marker = document.currentScript;
  const rawSource = marker?.dataset.bsCustomerMailRewardsSrc || '';
  let source;
  try {
    source = new URL(rawSource, document.baseURI);
  } catch (_error) {
    return;
  }
  if (
    source.protocol !== 'https:' ||
    source.username ||
    source.password ||
    source.port ||
    ![window.location.hostname, 'cdn.shopify.com'].includes(source.hostname)
  ) {
    return;
  }

  let observer = null;
  let loadPromise = null;
  let loadAttempts = 0;

  const load = () => {
    if (typeof window.BallonnenshopCustomerMailRewards?.start === 'function') {
      window.BallonnenshopCustomerMailRewards.start();
      return Promise.resolve();
    }
    if (loadPromise) return loadPromise;
    if (loadAttempts >= MAX_LOAD_ATTEMPTS) {
      return Promise.reject(new Error('CUSTOMER_MAIL_REWARDS_SCRIPT_UNAVAILABLE'));
    }
    loadAttempts += 1;
    loadPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(
        '[data-bs-customer-mail-rewards-script]'
      );
      if (existing?.dataset.bsLoaded === 'true') {
        reject(new Error('CUSTOMER_MAIL_REWARDS_RUNTIME_UNAVAILABLE'));
        return;
      }
      const script = existing || document.createElement('script');
      const loaded = () => {
        script.dataset.bsLoaded = 'true';
        if (typeof window.BallonnenshopCustomerMailRewards?.start !== 'function') {
          reject(new Error('CUSTOMER_MAIL_REWARDS_RUNTIME_UNAVAILABLE'));
          return;
        }
        window.BallonnenshopCustomerMailRewards.start();
        resolve();
      };
      const failed = () => {
        script.remove();
        reject(new Error('CUSTOMER_MAIL_REWARDS_SCRIPT_UNAVAILABLE'));
      };
      script.addEventListener('load', loaded, { once: true });
      script.addEventListener('error', failed, { once: true });
      if (!existing) {
        script.src = source.href;
        script.async = true;
        script.dataset.bsCustomerMailRewardsScript = '';
        document.head.append(script);
      }
    }).catch((error) => {
      loadPromise = null;
      throw error;
    });
    return loadPromise;
  };

  const loadWhenAccountExists = () => {
    if (!document.querySelector('[data-bs-account-modal]')) return false;
    observer?.disconnect();
    observer = null;
    void load().catch(() => {
      if (loadAttempts < MAX_LOAD_ATTEMPTS) {
        window.setTimeout(loadWhenAccountExists, RETRY_DELAY_MS);
      }
    });
    return true;
  };

  const observe = () => {
    if (loadWhenAccountExists() || observer || !document.documentElement) return;
    observer = new MutationObserver(loadWhenAccountExists);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  window.BallonnenshopCustomerMailRewardsLoader = Object.freeze({ load });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
